export default process.env.REACT_APP_USER_ACCOUNT_URL